import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations as allTranslations, defaultLanguage } from '../locales';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    return localStorage.getItem('selectedLanguage') || defaultLanguage;
  });

  const [translations, setTranslations] = useState(allTranslations[currentLanguage]);

  useEffect(() => {
    // Update translations when language changes
    setTranslations(allTranslations[currentLanguage]);
    // Save to localStorage
    localStorage.setItem('selectedLanguage', currentLanguage);
  }, [currentLanguage]);

  const changeLanguage = (languageCode) => {
    if (allTranslations[languageCode]) {
      setCurrentLanguage(languageCode);
    }
  };

  const t = (key) => {
    // Helper function to get nested translation values
    const keys = key.split('.');
    let value = translations;
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        console.warn(`Translation key "${key}" not found for language "${currentLanguage}"`);
        return key; // Return the key if translation not found
      }
    }
    
    return value;
  };

  const value = {
    currentLanguage,
    changeLanguage,
    t,
    translations,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
